import * as fs from "fs";
import path = require("path");
import { Converter } from "./converter";
import { Constants } from "./constants";
import { Utilities } from "./utilities";

function initialize() {
  Utilities.setUpOSFAppTelemetry();
}

export async function convert(
  inputXmlFilePath: string,
  outputJsonFolderPath: string,
  imageDownload: boolean = false,
  schemaOverride: string = null,
  schemaVersionOverride: string = null,
  verbose: boolean = false,
): Promise<void> {
  initialize();
  Utilities.setInputXmlFilePath(inputXmlFilePath);

  if (Utilities.isNullOrUndefined(imageDownload)) {
    imageDownload = false;
  }

  Utilities.setDownloadImages(imageDownload);

  // This option is currently always enabled and is no longer specified by the customer but kept internally for now
  var imageUrls: boolean = true;

  if (Utilities.isNullOrUndefined(imageUrls)) {
    imageUrls = false;
  }

  Utilities.setWriteImageUrls(imageUrls);

  if (Utilities.isNullOrUndefined(verbose)) {
    verbose = false;
  }

  Utilities.setVerbosity(verbose);

  if (!Utilities.isNullOrUndefined(schemaOverride)) {
    Utilities.setSchemaOverride(schemaOverride);
  }

  if (!Utilities.isNullOrUndefined(schemaVersionOverride)) {
    Utilities.setSchemaVersionOverride(schemaVersionOverride);
  }

  const inputXml: string = fs.readFileSync(inputXmlFilePath, "utf8");
  let basename: string = path.basename(inputXmlFilePath);
  if (path.extname(basename).toLowerCase() === ".xml") {
    basename = basename.slice(0, -4);
  }

  // In case no output folder is given, write to a new folder as the sibling of the input XML file
  let outputFolder: string = outputJsonFolderPath;
  if (Utilities.isNullOrUndefined(outputFolder) || outputFolder.trim().length == 0) {
    outputFolder = path.dirname(inputXmlFilePath) + "/" + basename;
  }

  Utilities.ensureFolder(outputFolder);

  const converter: Converter = new Converter(inputXml, "en-US");
  await converter.convert();

  await converter.downloadAndStoreIcons(outputFolder);

  // Write the main manifest file
  await writeMainManifestFile(converter, outputFolder);

  // Write locale files
  await writeLocaleFiles(converter, outputFolder);
}

async function writeMainManifestFile(converter: Converter, outputJSONFolderPath: string) {
  const manifestFilePath: string = outputJSONFolderPath + "/" + Constants.JSONManifestFileName;
  Utilities.log("manifest file path: " + manifestFilePath);
  const jsonResult = converter.getJSON();

  await Utilities.writeFile(
    manifestFilePath,
    JSON.stringify(jsonResult, null /* replacer */, 4 /* space */),
    "Error writing file",
    "Successfully wrote file: " + manifestFilePath,
  );
}

function writeLocaleFiles(converter: Converter, outputJSONPath: string): Promise<void> {
  return new Promise<void>(async (resolve, reject) => {
    let locales: string[] = converter.getLocaleBuilder().getLocales();
    let promises: Promise<void>[] = [];
    Utilities.log("locales seen by legacy parser: " + locales);
    // Write file for each language that is present in the manifest
    for (let i: number = 0; i < locales.length; i++) {
      let locale: string = locales[i];
      let localeFilePath: string = outputJSONPath + "/" + Utilities.createLocaleFileName(locale);
      Utilities.log("locale file path: " + localeFilePath);
      promises.push(
        Utilities.writeFile(
          localeFilePath,
          JSON.stringify(
            converter.getLocaleBuilder().getLocaleFileResources(locale),
            null /* replacer */,
            4 /* space */,
          ),
          "Error writing file",
          "Successfully wrote file: " + localeFilePath,
        ),
      );
    }

    await Utilities.promiseAll(promises, resolve, reject, "writeLocalFiles:Failed");
  });
}
